module.exports = __webpack_public_path__ + "img/26.70541022.jpg";